import React from 'react'
import axios from 'axios'
import './rotasModule.css'
import RotasReportFilters from './RotasReportFilters'
import { formatDate } from './rotaHelpers'
import { ensurePdfResponse, extractBlobErrorMessage, openPdfBlob } from '../../utils/openPdfBlob'

export default class RotasCoord extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            fiscals: [],
            items: [],
            loaded: false,
            filters: {
                fiscal: 'Todos',
                inicial: '',
                final: '',
                estado: 'todos',
                situacao: 'todas',
                realizada: 'todas'
            }
        }
    }

    componentDidMount() {
        axios('/api/user/getFiscais')
            .then((resp) => this.setState({ fiscals: resp.data }))
            .catch((error) => alert(error.response?.data || 'Erro ao carregar fiscais.'))
    }

    updateField = (event) => {
        this.setState({ filters: { ...this.state.filters, [event.target.name]: event.target.value } })
    }

    buildReportPayload = () => {
        const { fiscal, estado, situacao, realizada, inicial, final } = this.state.filters

        return { fiscal, estado, situacao, realizada, inicial, final }
    }

    buscar = async () => {
        try {
            const resp = await axios.post('/api/rota/relatorio', this.buildReportPayload())
            const items = resp.data?.items || []
            this.setState({ items, loaded: true })
        } catch (error) {
            alert(error.response?.data || 'Erro ao carregar relatório.')
        }
    }

    abrirPdfGeral = async () => {
        const pdfWindow = window.open('', '_blank', 'noopener,noreferrer')

        try {
            const response = await axios.post('/api/rota/relatorio/pdf', this.buildReportPayload(), {
                responseType: 'blob'
            })
            const pdfData = await ensurePdfResponse(response, 'Não foi possível gerar o PDF do relatório.')

            openPdfBlob({
                data: pdfData,
                filename: 'relatorio-geral-rotas.pdf',
                targetWindow: pdfWindow
            })
        } catch (error) {
            if (pdfWindow && !pdfWindow.closed) {
                pdfWindow.close()
            }

            const message = error instanceof Error && error.message
                ? error.message
                : await extractBlobErrorMessage(error, 'Erro ao gerar PDF do relatório.')

            alert(message || 'Erro ao gerar PDF do relatório.')
        }
    }

    renderTable() {
        if (!this.state.loaded) return null
        return (
            <div className="rota-surface">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                        <p className="rota-eyebrow mb-1">Resultado</p>
                        <h3 className="rota-section-title mb-0">Itens encontrados</h3>
                    </div>
                    <div className="d-flex align-items-center flex-wrap" style={{ gap: '0.75rem' }}>
                        <span className="rota-muted">{this.state.items.length} registro(s)</span>
                        <button className="btn rota-secondary-button" onClick={this.abrirPdfGeral}>Relatório em PDF</button>
                    </div>
                </div>
                <div className="table-responsive">
                    <table className="table table-borderless mb-0">
                        <thead>
                            <tr>
                                <th>Fiscal</th>
                                <th>Estado</th>
                                <th>Tipo</th>
                                <th>Estabelecimento</th>
                                <th>Data</th>
                                <th>Município</th>
                                <th>Situação</th>
                                <th>Execução</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.items.map((item) => (
                                <tr key={`${item.fiscal}-${item.tipoItem}-${item.indice}-${item.data}`}>
                                    <td>{item.fiscal}</td>
                                    <td>{item.estado}</td>
                                    <td>{item.tipoItem === 'alternativa' ? 'Alternativa' : 'Principal'}</td>
                                    <td>{item.estabelecimento || 'Não informado'}</td>
                                    <td>{formatDate(item.data)}</td>
                                    <td>{item.municipio || 'Não informado'}</td>
                                    <td>{item.situacao}</td>
                                    <td>{item.realizada === null ? 'Pendente' : item.realizada ? 'Realizada' : 'Não realizada'}</td>
                                </tr>
                            ))}
                            {this.state.items.length === 0 && <tr><td colSpan="8" className="text-center rota-muted">Nenhum item encontrado para os filtros informados.</td></tr>}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className="container rota-page">
                <div className="rota-hero">
                    <p className="rota-eyebrow mb-1">Relatórios de rotas</p>
                    <h1 className="rota-title mb-2">Painel analítico do módulo</h1>
                    <p className="rota-subtitle mb-0">Use filtros enxutos por período, fiscal, estado, situação e execução.</p>
                </div>
                <RotasReportFilters fiscals={this.state.fiscals} filters={this.state.filters} onChange={this.updateField} onSubmit={this.buscar} />
                {this.renderTable()}
            </div>
        )
    }
}
